import { FormInput, InfoAlert, Text } from '@/components';
import {
  WalletTokenInterface,
  WalletUnderlyingYieldBearingAssetInterface,
} from '@/interfaces';
import {
  formatNumberToAmountInTokenCurrencyString,
  formatNumberToAmountInUsdString,
} from '@/utils/formatUtils';
import { convertTokenAmountToUsd } from '@/utils/functionalUtils';
import { TRADE_CARD } from '@/utils/strings';
import { FC, useMemo } from 'react';
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
type SellableAssetType =
  | WalletTokenInterface
  | WalletUnderlyingYieldBearingAssetInterface;
interface Props {
  selectedAsset: SellableAssetType | null;
  amountInTokenCurrency: string;
  handleMaxClick: () => void;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  clearErrors: UseFormClearErrors<any>;
  errors: FieldErrors<any>;
}
const SellWalletTokenOrUnderlyingYieldBearingAssetAmountInputs: FC<Props> = ({
  selectedAsset,
  amountInTokenCurrency,
  handleMaxClick,
  register,
  clearErrors,
  errors,
}) => {
  const usdSubtitle = useMemo(() => {
    if (!selectedAsset?.priceInUsd) return 'USD';
    const tokenAmount = parseFloat(amountInTokenCurrency || '0');
    const usdValue = convertTokenAmountToUsd(tokenAmount, selectedAsset);
    return `${formatNumberToAmountInTokenCurrencyString(
      tokenAmount,
      selectedAsset.symbol || '',
    )} (${formatNumberToAmountInUsdString(usdValue)})`;
  }, [amountInTokenCurrency, selectedAsset]);
  return (
    <FormInput
      name="amount"
      type="number"
      label={TRADE_CARD.SCREENS.TRADE.LABELS.AMOUNT_TRADED_FIELD.LABEL}
      subtitle={usdSubtitle}
      defaultValue={amountInTokenCurrency}
      register={register}
      errors={errors}
      clearErrors={clearErrors}
      suffix={
        <Text
          value="Max"
          color="accent"
          className="font-medium cursor-pointer"
          onClick={handleMaxClick}
        />
      }
      tooltip={
        <InfoAlert
          title={
            TRADE_CARD.SCREENS.TRADE.LABELS.AMOUNT_TRADED_FIELD.TOOLTIP_TITLE
          }
          description={
            TRADE_CARD.SCREENS.TRADE.LABELS.AMOUNT_TRADED_FIELD
              .TOOLTIP_DESCRIPTION
          }
          intent="transparent"
        />
      }
      tooltipIsFullBleed
      showPercentageDial
      maxAmount={selectedAsset?.balance}
    />
  );
};
export default SellWalletTokenOrUnderlyingYieldBearingAssetAmountInputs;
